import { THEME_DETAILS_SLUG_UPDATED, THEME_DETAILS_SLUG_RESET } from './ActionTypes';
export const updateThemeSlug = slug => dispatch => dispatch({
  type: THEME_DETAILS_SLUG_UPDATED,
  payload: slug
});
export const resetThemeSlug = () => dispatch => dispatch({
  type: THEME_DETAILS_SLUG_RESET
});